import { gql } from "@apollo/client"
import { NOTIFICATION_FRAGMENT } from "@graphql"

const CREATE_NOTIFICATION_MUTATION = gql`
  ${NOTIFICATION_FRAGMENT}
  
  mutation createNotification($input: CreateNotificationInput!) {  
    createNotification(input: $input) {
      ...NotificationFields
    }
  }
`

export { CREATE_NOTIFICATION_MUTATION }